import { HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Panel from "@ui/panel/Panel";
import Spacer from "@ui/spacer/Spacer";
import { Typo } from "@ui/text/Typo";
import Signal from "badmfck-signal";
import { useEffect } from "react";
import { registerSystemBackOverlay } from "@ui/utils/systemBack";

export const S_CONFIRM = new Signal<{
	title?: string;
	message: string;
	confirm?: string;
	reject?: string;
	onResult: (val: "confirm" | "reject") => void;
} | null>("S_CONFIRM");

export const confirmAction = (options: { title: string; message: string; confirm?: string }) =>
	new Promise<boolean>(resolve => S_CONFIRM.invoke({ ...options, reject: "Cancel", onResult: result => resolve(result === "confirm") }));

export const ConfirmDialog = () => {
	const requestData = S_CONFIRM.use();
	useEffect(() => {
		if (!requestData) return;
		return registerSystemBackOverlay(() => {
			requestData.onResult("reject");
			S_CONFIRM.invoke(null);
		});
	}, [requestData]);

	if (!requestData) return null;

	const handleSubmit = async () => {
		if (requestData && requestData.onResult) {
			requestData.onResult("confirm");
		}
		closePopup();
	};

	const closePopup = () => {
		S_CONFIRM.invoke(null);
	};

	const rejectPopup = () => {
		if (requestData && requestData.onResult) {
			requestData.onResult("reject");
		}
		closePopup();
	};

	return (
		<Panel
			growContent
			sx={{
					maxWidth: "560px",
				padding: "0",
				minWidth: "500px",
			}}
			decorator="absolute"
			label={requestData.title ?? "Confirm"}
			onClose={rejectPopup}>
			<VBox
				gap="12px"
				sx={{
					overflow: "auto",
					flexGrow: 1,
						padding: "0",
				}}>
				<Typo variant="text" sx={{ lineHeight: 1.55, color: "#475569" }}>{requestData.message}</Typo>
			</VBox>

			<Spacer size="20px" />

			<HBox sx={{ gap: "12px", width: "100%" }}>
				{requestData.reject && (
					<Button
						variant="secondary"
						sx={{ flex: 1, minHeight: "44px" }}
						title={requestData.reject}
						onClick={() => {
							rejectPopup();
						}}
					/>
				)}
				<Button
					sx={{ flex: 1, minHeight: "44px" }}
					title={requestData.confirm ?? "OK"}
					onClick={() => {
						handleSubmit();
					}}
				/>
			</HBox>
		</Panel>
	);
};
